import { useEffect, useState } from "react";

import {
  type AssertValidParams,
  FilterParams,
  type ParamsConstraint,
} from "./filter-params";
import type { FilterParamsHandle } from "./use-filter-params";

export const useDebouncedFilterParams = <T extends ParamsConstraint>(
  handle: FilterParamsHandle<T>,
  wait: number,
): FilterParams<T> => {
  const [debouncedParams, setDebouncedParams] = useState(
    () =>
      new FilterParams<T>(
        handle.toObject() as Partial<T & AssertValidParams<T>>,
      ),
  );

  const currentString = handle.toString();

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedParams(
        new FilterParams<T>(
          handle.toObject() as Partial<T & AssertValidParams<T>>,
        ),
      );
    }, wait);

    return () => clearTimeout(timer);
  }, [currentString, handle, wait]);

  return debouncedParams;
};
